// removed by extract-text-webpack-plugin
module.exports = {"container":"_2lvWnbdfs5g5Yn5lbOjHql","block":"_2FIfP--316VjX6VM_h8oRK","withImage":"_3On2bXdHKhehEeyk4b49BZ","quote":"_1NS0N_W-HZ2Zpr67Eqqcj9","yellow":"_20eBTSDWMdnPM1YxgitFky","blue":"_1EFnX8kGgf5wwDkGnYZHfG","author":"ymGGWbN3fGTdZb1ExK2OV"};


//////////////////
// WEBPACK FOOTER
// ./src/components/QuoteBlock/QuoteBlock.module.scss
// module id = 802
// module chunks = 0